/*
 * @Author: xuejian3721
 * @Date: 2024-10-28 15:33:20
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-10-30 16:52:48
 */
export const WS_CONFIG = {
  HEARTBEAT_INTERVAL: 10000, // 心跳间隔时间（毫秒）
  RECONNECT_INTERVAL: 3000, // 重连间隔时间（毫秒）
  MESSAGE_TIMEOUT: 0, // 消息超时时间（毫秒）
  MAX_RECONNECT_ATTEMPTS: 5 // 最大重连尝试次数
}

let _msgNo = 0 // 消息流水号
// 获取唯一消息ID
export function getRequestId() {
  _msgNo++
  return Date.now().toString() + _msgNo.toString()
}
